import { render, staticRenderFns } from "./iconsCard.vue?vue&type=template&id=3a1b798a&scoped=true"
import script from "./iconsCard.vue?vue&type=script&lang=js"
export * from "./iconsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b798a",
  null
  
)

export default component.exports